import { useState } from "react"
import { Carousel, CarouselItem, Modal } from "react-bootstrap"
import { ReactComponent as PrevIcon } from "../common/carousel_left.svg"
import { ReactComponent as NextIcon } from "../common/carousel_right.svg"

interface ShopGalleryProps {
  photos: string[]
}

// Photos shown in the desktop mosaic, the others are reachable from the full screen gallery
const MOSAIC_PHOTOS = 3

export default function ShopGallery({ photos }: Readonly<ShopGalleryProps>) {
  const [mobileIndex, setMobileIndex] = useState(0)
  const [modalIndex, setModalIndex] = useState<number>()

  if (photos.length === 0) return null

  const mosaicPhotos = photos.slice(0, MOSAIC_PHOTOS)

  return (
    <>
      {/* Desktop: mosaic of the first photos, a click opens the full screen gallery */}
      <div className={`shop-gallery-mosaic shop-gallery-mosaic-${mosaicPhotos.length} d-none d-lg-grid`}>
        {mosaicPhotos.map((photo, index) => (
          <button
            type="button"
            className="shop-gallery-tile"
            key={index}
            aria-label={`Apri la foto ${index + 1} di ${photos.length}`}
            onClick={() => setModalIndex(index)}
          >
            <img src={photo} alt="" />
          </button>
        ))}
        {photos.length > MOSAIC_PHOTOS ? (
          <button type="button" className="shop-gallery-all" onClick={() => setModalIndex(0)}>
            Vedi tutte le foto ({photos.length})
          </button>
        ) : null}
      </div>

      {/* Mobile: full width carousel with a photo counter */}
      <div className="shop-gallery-mobile d-lg-none">
        <Carousel
          interval={null}
          indicators={false}
          controls={photos.length > 1}
          activeIndex={mobileIndex}
          onSelect={setMobileIndex}
          prevIcon={<PrevIcon className="custom-carousel-icon" />}
          nextIcon={<NextIcon className="custom-carousel-icon" />}
        >
          {photos.map((photo, index) => (
            <CarouselItem key={index}>
              <img src={photo} className="shop-gallery-mobile-img" alt={`Foto ${index + 1} di ${photos.length}`} />
            </CarouselItem>
          ))}
        </Carousel>
        {photos.length > 1 ? (
          <span className="shop-gallery-counter">
            {mobileIndex + 1} / {photos.length}
          </span>
        ) : null}
      </div>

      <Modal
        show={modalIndex !== undefined}
        onHide={() => setModalIndex(undefined)}
        size="xl"
        centered
        contentClassName="shop-gallery-modal"
      >
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title as="span">
            {(modalIndex ?? 0) + 1} / {photos.length}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Carousel
            interval={null}
            indicators={false}
            controls={photos.length > 1}
            activeIndex={modalIndex ?? 0}
            onSelect={setModalIndex}
            prevIcon={<PrevIcon className="custom-carousel-icon" />}
            nextIcon={<NextIcon className="custom-carousel-icon" />}
          >
            {photos.map((photo, index) => (
              <CarouselItem key={index}>
                <img src={photo} className="shop-gallery-modal-img" alt={`Foto ${index + 1} di ${photos.length}`} />
              </CarouselItem>
            ))}
          </Carousel>
        </Modal.Body>
      </Modal>
    </>
  )
}
